import React, { Component } from "react";
import { jsPDF } from "jspdf";
import moment from "moment";
import { Row, Spinner, Col } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import { components } from 'react-select';
import SelectDropDown from '../selectdropdown/SelectDropDown';

/* -------------------- GRAPHQL -------------------- */
const GET_CREATED_EXAMS = gql`
  query getCreatedExams($class_id: String, $stream_ids: String, $exam_phase_id: Int!) {
    getCreatedExams(class_id: $class_id, stream_ids: $stream_ids, exam_phase_id: $exam_phase_id) {
      id
      subject_id
      subject_name
      order_no
      exam_date
      class_id
      class_name
      stream_id
      stream_name
    }
  }
`;

const CREATE_EXAMS = gql`
  mutation createExams(
    $class_id: Int!
    $stream_id: Int
    $exam_phase_id: Int!
    $exams: [ExamInput!]!
  ) {
    createExams(
      class_id: $class_id
      stream_id: $stream_id
      exam_phase_id: $exam_phase_id
      exams: $exams
    )
  }
`;

const GET_ORGANISATION_PROFILE = gql`
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id) {
            id
            organisation_name
            logo
            complete_address
        }
    }
`;

/* -------------------- COMPONENT -------------------- */

class CreateExam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBranch: "",
      selectedClasses: [],
      selectedStreams: [],
      selectedExamPhase: "",
      selectedAcademicYear: "",
      tableData: { subjects: [], streamGroups: [] },
      isSubmitting: false,
      loader: 0,
      errors: {},
      isSubmit: false,
      showConfig: false,
      orgProfile: {},
      searchQuery: "",
      currentPage: 1,
      pageSize: 10,
    };
  }

  // Returns { subjects, streamGroups }
  //   subjects     = all unique subjects (used for exports / counts)
  //   streamGroups = [{ stream_id, stream_name, subjects, classes }]
  //     one group per stream (MPC, HEC, …); each group has its OWN subject columns and its
  //     class rows, so the table can render "stream -> class -> subject-wise date & order".
  mapApiToState = (data = []) => {
    const subjectMap = new Map();
    const groupMap = new Map();

    data.forEach((item) => {
      if (!subjectMap.has(item.subject_id)) {
        subjectMap.set(item.subject_id, {
          subject_id: item.subject_id,
          subject_name: item.subject_name,
        });
      }

      const hasStream = item.stream_id != null && item.stream_id !== "";
      const streamKey = hasStream ? String(item.stream_id) : "none";
      if (!groupMap.has(streamKey)) {
        groupMap.set(streamKey, {
          stream_id: hasStream ? item.stream_id : null,
          stream_name: item.stream_name || "",
          subjectMap: new Map(),
          classesMap: new Map(),
        });
      }
      const grp = groupMap.get(streamKey);
      if (!grp.subjectMap.has(item.subject_id)) {
        grp.subjectMap.set(item.subject_id, {
          subject_id: item.subject_id,
          subject_name: item.subject_name,
        });
      }

      const classKey = String(item.class_id);
      if (!grp.classesMap.has(classKey)) {
        grp.classesMap.set(classKey, {
          class_id: item.class_id,
          class_name: item.class_name,
          stream_id: grp.stream_id,
          stream_name: grp.stream_name,
          exams: {},
        });
      }
      const cls = grp.classesMap.get(classKey);
      const subjectIndex = Array.from(grp.subjectMap.keys()).indexOf(item.subject_id) + 1;
      const [loadedDate, loadedTime] = (item.exam_date || "").split(/T| /);
      cls.exams[item.subject_id] = {
        id: item.id,
        subject_id: item.subject_id,
        exam_date: loadedDate || "",
        exam_time: loadedTime ? loadedTime.slice(0, 5) : "",
        order_no: item.order_no || subjectIndex,
      };
    });

    const streamGroups = Array.from(groupMap.values()).map((g) => ({
      stream_id: g.stream_id,
      stream_name: g.stream_name,
      subjects: Array.from(g.subjectMap.values()),
      classes: Array.from(g.classesMap.values()),
    }));

    return {
      subjects: Array.from(subjectMap.values()),
      streamGroups,
    };
  };

  // Flatten all class rows across stream groups (for exports / counts).
  getAllClasses = () => (this.state.tableData.streamGroups || []).flatMap((g) => g.classes);

  componentDidMount() {
    const firstYear = this.props.getYears?.[0];
    if (firstYear) {
      this.setState({ selectedAcademicYear: String(firstYear.id) });
    }
    this.loadOrgProfile();
  }

  getLogoUrl = (logoFile) => {
    if (!logoFile) return "";
    if (logoFile.startsWith("http://") || logoFile.startsWith("https://")) return logoFile;
    return `https://support.rizee.in/files/${logoFile}`;
  };

  loadOrgProfile = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_ORGANISATION_PROFILE,
        variables: { institution_id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: "network-only",
      });
      const data = result.data?.getOrganisationProfile;
      const profile = {
        organisation_name: data?.organisation_name || "",
        complete_address: data?.complete_address || "",
        logo: data?.logo || "",
      };

      this.setState({ orgProfile: profile });
      return profile;
    } catch (err) {
      console.error("loadOrgProfile error:", err);
      return this.state.orgProfile;
    }
  };



  handleFetchData = async () => {
    const { selectedClasses, selectedStreams, selectedExamPhase, selectedAcademicYear } = this.state;
    if (!selectedClasses.length || !selectedExamPhase || !selectedAcademicYear) {
      toast.error("Please select all filters");
      return;
    }
    this.setState({ loader: 1 });
    try {
      const res = await this.props.client.query({
        query: GET_CREATED_EXAMS,
        variables: {
          class_id: selectedClasses.map((item) => item.value).join(","),
          stream_ids: selectedStreams.length ? selectedStreams.map((item) => item.value).join(",") : null,
          exam_phase_id: +selectedExamPhase,
        },
        fetchPolicy: "no-cache",
      });
      const apiData = res?.data?.getCreatedExams || [];
      this.setState({
        tableData: this.mapApiToState(apiData),
        showConfig: true,
        searchQuery: "",
        currentPage: 1,
      });
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch data");
    } finally {
      this.setState({ loader: 0 });
    }
  };

  handleFormChange = (e) => {
    const { name, value } = e.target;
    const reset = {
      tableData: { subjects: [], streamGroups: [] },
      isSubmitting: false,
      loader: 0,
      errors: {},
      isSubmit: false,
      showConfig: false,
      searchQuery: "",
      currentPage: 1,
    };
    const extraReset = name === "selectedBranch" ? { selectedClasses: [], selectedStreams: [] } : {};
    this.setState({ [name]: value, ...reset, ...extraReset }, () => {
      if (name === "selectedBranch" && value) {
        const allOptions = this.getClassOptions();
        this.setState({ selectedClasses: allOptions }, () => {
          const allStreams = this.getStreamOptions();
          this.setState({ selectedStreams: allStreams }, () => {
            const { selectedClasses, selectedExamPhase, selectedAcademicYear } = this.state;
            if (selectedClasses.length && selectedExamPhase && selectedAcademicYear) {
              this.handleFetchData();
            }
          });
        });
      } else {
        const { selectedClasses, selectedExamPhase, selectedAcademicYear } = this.state;
        if (selectedClasses.length && selectedExamPhase && selectedAcademicYear) {
          this.handleFetchData();
        }
      }
    });
  };

  handleSelectChange = (name, value) => {
    const reset = {
      tableData: { subjects: [], streamGroups: [] },
      isSubmitting: false,
      loader: 0,
      errors: {},
      isSubmit: false,
      showConfig: false,
      searchQuery: "",
      currentPage: 1,
    };
    // Class is single-select now — changing the Branch just clears the class/stream and
    // waits for the user to pick ONE class (no auto-select-all).
    const extraReset = name === "selectedBranch" ? { selectedClasses: [], selectedStreams: [] } : {};
    this.setState({ [name]: String(value), ...reset, ...extraReset }, () => {
      const { selectedClasses, selectedExamPhase, selectedAcademicYear } = this.state;
      if (selectedClasses.length && selectedExamPhase && selectedAcademicYear) {
        this.handleFetchData();
      }
    });
  };

  handleClassChange = (selected) => {
    this.setState(
      {
        selectedClasses: selected,
        selectedStreams: [],
        tableData: { subjects: [], streamGroups: [] },
        showConfig: false,
        errors: {},
        isSubmit: false,
        selectedExamPhase: "",
        searchQuery: "",
        currentPage: 1,
      },
      () => {
        // Auto-select all available streams (e.g. for 11/12); user can deselect after
        const allStreams = this.getStreamOptions();
        this.setState({ selectedStreams: allStreams }, () => {
          const { selectedClasses, selectedExamPhase, selectedAcademicYear } = this.state;
          if (selectedClasses.length && selectedExamPhase && selectedAcademicYear) {
            this.handleFetchData();
          }
        });
      }
    );
  };

  // Single-select Class. Kept as a one-item array internally so all downstream logic
  // (streams / fetch / grouping) that expects `selectedClasses` as a list still works.
  handleClassSingleChange = (name, value) => {
    const opt = this.getClassOptions().find((o) => String(o.value) === String(value));
    this.handleClassChange(opt ? [opt] : []);
  };

  handleStreamChange = (selected) => {
    this.setState({ selectedStreams: selected }, () => {
      const { selectedClasses, selectedExamPhase, selectedAcademicYear } = this.state;
      if (selectedClasses.length && selectedExamPhase && selectedAcademicYear) {
        this.handleFetchData();
      }
    });
  };

  getStreamOptions = () => {
    const { getStreams } = this.props;
    const { selectedClasses } = this.state;
    if (!getStreams?.length || !selectedClasses.length) return [];
    const selectedClassIds = selectedClasses.map((c) => Number(c.value));
    return (getStreams || [])
      .filter((st) => {
        const classCsv = String(st.classes || "").split(",").map((v) => Number(v.trim())).filter(Boolean);
        return classCsv.some((cid) => selectedClassIds.includes(cid));
      })
      .map((st) => ({ value: st.id, label: st.stream }));
  };

  getFilteredClasses = () => {
    const { getBranchesQuery, getClasses } = this.props;
    const { selectedBranch } = this.state;
    if (!selectedBranch) return [];
    const branches = getBranchesQuery || [];
    const branch = branches.find((b) => String(b.id) === selectedBranch);
    if (!branch) return [];
    const classIds = [...new Set(branch.sections.map((s) => s.class_id))];
    return (getClasses || []).filter((c) => classIds.includes(c.id));
  };

  sortClassesByName = (classes) =>
    [...(classes || [])].sort((a, b) =>
      String(a.value ?? "").localeCompare(
        String(b.value ?? ""),
        undefined,
        { sensitivity: "base", numeric: true }
      )
    );

  getClassOptions = () =>
    this.sortClassesByName(
      this.getFilteredClasses().map((c) => ({ label: c.class, value: c.id }))
    );

  // Match the class within its stream group (a class_id can exist under several streams).
  sameStream = (a, b) => String(a ?? "none") === String(b ?? "none");

  updateExamField = (streamId, classId, subjectId, key, value) => {
    const streamGroups = (this.state.tableData.streamGroups || []).map((g) => {
      if (!this.sameStream(g.stream_id, streamId)) return g;
      return {
        ...g,
        classes: g.classes.map((cls) => {
          if (String(cls.class_id) !== String(classId)) return cls;
          return {
            ...cls,
            exams: { ...cls.exams, [subjectId]: { ...cls.exams[subjectId], [key]: value } },
          };
        }),
      };
    });
    this.setState({ tableData: { ...this.state.tableData, streamGroups } });
  };

  handleDateTimeChange = (streamId, classId, subjectId, datetimeValue) => {
    const [date, time] = (datetimeValue || "").split("T");
    const streamGroups = (this.state.tableData.streamGroups || []).map((g) => {
      if (!this.sameStream(g.stream_id, streamId)) return g;
      return {
        ...g,
        classes: g.classes.map((cls) => {
          if (String(cls.class_id) !== String(classId)) return cls;
          return {
            ...cls,
            exams: {
              ...cls.exams,
              [subjectId]: { ...cls.exams[subjectId], exam_date: date || "", exam_time: time || "" },
            },
          };
        }),
      };
    });
    this.setState({ tableData: { ...this.state.tableData, streamGroups } });
  };

  handlePublishExam = async () => {
    const { selectedExamPhase, tableData } = this.state;
    if (!selectedExamPhase) {
      toast.error("Please select Exam Phase");
      return;
    }

    const streamGroups = tableData.streamGroups || [];
    const streamTag = (g) => (g.stream_name ? ` (${g.stream_name})` : "");

    // Validate dates and order per class-stream row
    for (const g of streamGroups) {
      for (const cls of g.classes) {
        const allExams = Object.values(cls.exams);
        for (const e of allExams) {
          if (!e.exam_date || !e.exam_date.trim()) {
            const subj = g.subjects.find((s) => s.subject_id === e.subject_id);
            toast.error(`Please select exam date for ${subj?.subject_name} in ${cls.class_name}${streamTag(g)}`);
            return;
          }
        }
        const orders = allExams.map((e) => Number(e.order_no)).filter((n) => n > 0);
        const dup = orders.find((item, idx) => orders.indexOf(item) !== idx);
        if (dup !== undefined) {
          toast.error(`Order No ${dup} is duplicated in ${cls.class_name}${streamTag(g)}`);
          return;
        }
      }
    }

    this.setState({ isSubmitting: true });
    try {
      // One mutation per class-stream row → the selected stream_id is sent with each class.
      for (const g of streamGroups) {
        for (const cls of g.classes) {
          const exams = Object.values(cls.exams).map((e) => ({
            id: e.id || null,
            subject_id: e.subject_id,
            exam_date: e.exam_date && e.exam_time ? moment(`${e.exam_date} ${e.exam_time}`).format("YYYY-MM-DD HH:mm:ss") : e.exam_date,
            order_no: +e.order_no,
          }));
          await this.props.mutate({
            variables: {
              class_id: +cls.class_id,
              stream_id: cls.stream_id ? +cls.stream_id : null,
              exam_phase_id: +selectedExamPhase,
              inserted_by: parseInt(Cookies.get("id")),
              exams
            },
          });
        }
      }
      toast.success("Exam published successfully");
      this.setState({
        selectedClasses: [],
        selectedStreams: [],
        selectedExamPhase: "",
        tableData: { subjects: [], streamGroups: [] },
        isSubmitting: false,
        showConfig: false,
        searchQuery: "",
        currentPage: 1,
      });
    } catch (err) {
      console.error(err);
      toast.error("Error publishing exam");
      this.setState({ isSubmitting: false });
    }
  };

  generateHallTicketHTML = () => {
    const { tableData, selectedExamPhase } = this.state;
    const { subjects } = tableData;
    const classes = (tableData.streamGroups || []).flatMap((g) =>
      g.classes.map((cls) => ({ ...cls, class_name: cls.stream_name ? `${cls.class_name} - ${cls.stream_name}` : cls.class_name }))
    );
    const examPhase = this.props.getExamPhase?.find(
      (p) => String(p.id) === selectedExamPhase
    );
    const phaseName = examPhase?.exam_phase || "Exam Schedule";
    const institutionName = Cookies.get("institutionname") || "School";

    const rows = classes
      .map((cls) => {
        const checkedExams = Object.values(cls.exams)
          .filter((e) => e.exam_date)
          .sort((a, b) => a.order_no - b.order_no);
        return checkedExams
          .map(
            (e) => `
          <tr>
            <td>${cls.class_name}</td>
            <td>${e.order_no}</td>
            <td style="text-align:left; padding-left:16px">${subjects.find((s) => s.subject_id === e.subject_id)?.subject_name || ""
              }</td>
            <td>${e.exam_date}</td>
            <td>${e.exam_time || "-"}</td>
          </tr>`
          )
          .join("");
      })
      .join("");

    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>Exam Hall Ticket</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, sans-serif; padding: 40px; color: #000; }
    .header { text-align: center; margin-bottom: 28px; }
    .header h2 { font-size: 20px; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; }
    .header h3 { font-size: 16px; font-weight: 700; margin-top: 6px; text-transform: uppercase; }
    table { width: 100%; border-collapse: collapse; margin-top: 16px; }
    th { background: #222; color: #fff; padding: 10px 12px; font-size: 13px; text-align: center; letter-spacing: 0.5px; text-transform: uppercase; }
    td { border: 1px solid #bbb; padding: 10px 12px; font-size: 13px; text-align: center; }
    tr:nth-child(even) td { background: #f5f5f5; }
    .footer { margin-top: 30px; font-size: 12px; color: #555; text-align: center; }
  </style>
</head>
<body>
  <div class="header">
    <h2>${institutionName}</h2>
    <h3>${phaseName}</h3>
  </div>
  <table>
    <thead>
      <tr>
        <th>Class</th>
        <th>Order</th>
        <th>Subject</th>
        <th>Date</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>${rows}</tbody>
  </table>
  <div class="footer">Generated on ${new Date().toLocaleDateString()}</div>
</body>
</html>`;
  };

  prepareTimetableExport = async () => {
    const { tableData, selectedExamPhase } = this.state;
    let orgProfile = this.state.orgProfile || {};
    if (!orgProfile.logo) {
      orgProfile = (await this.loadOrgProfile()) || orgProfile;
    }
    const { subjects } = tableData;
    const classes = (tableData.streamGroups || []).flatMap((g) =>
      g.classes.map((cls) => ({ ...cls, class_name: cls.stream_name ? `${cls.class_name} - ${cls.stream_name}` : cls.class_name }))
    );
    const examPhase = this.props.getExamPhase?.find((p) => String(p.id) === selectedExamPhase);
    const phaseName = examPhase?.exam_phase || "Exam Schedule";

    const colSet = new Map();
    classes.forEach((cls) => {
      Object.values(cls.exams).forEach((exam) => {
        if (!exam.exam_date) return;
        const hour = exam.exam_time ? parseInt(exam.exam_time.split(":")[0], 10) : 9;
        const session = hour < 12 ? "MORNING" : "AFTERNOON";
        const key = `${exam.exam_date}|${session}`;
        if (!colSet.has(key)) colSet.set(key, { date: exam.exam_date, session });
      });
    });

    const columns = Array.from(colSet.values()).sort((a, b) => {
      const d = a.date.localeCompare(b.date);
      return d !== 0 ? d : a.session === "MORNING" ? -1 : 1;
    });

    if (columns.length === 0) {
      toast.error("No exam data to export");
      return null;
    }

    const gridRows = classes.map((cls) => ({
      className: cls.class_name,
      cells: columns.map((col) => {
        const matches = Object.values(cls.exams).filter((e) => {
          if (!e.exam_date || e.exam_date !== col.date) return false;
          const h = e.exam_time ? parseInt(e.exam_time.split(":")[0], 10) : 9;
          return (h < 12 ? "MORNING" : "AFTERNOON") === col.session;
        });
        return matches
          .map((e) => subjects.find((s) => s.subject_id === e.subject_id)?.subject_name || "")
          .filter(Boolean)
          .join("\n");
      }),
    }));

    const dateGroups = [];
    columns.forEach((col, i) => {
      const last = dateGroups[dateGroups.length - 1];
      if (!last || last.date !== col.date) {
        dateGroups.push({ date: col.date, start: i, count: 1 });
      } else {
        last.count++;
      }
    });

    return {
      columns,
      gridRows,
      dateGroups,
      phaseName,
      orgProfile,
      logoUrl: this.getLogoUrl(orgProfile.logo),
      orgName: (orgProfile.organisation_name || Cookies.get("institutionname") || "School").toUpperCase(),
      orgAddress: orgProfile.complete_address || "",
      monthYear: moment().format("MMMM YYYY"),
      landscape: columns.length > 3,
    };
  };

  generateTimetablePrintHTML = (data) => {
    const { columns, gridRows, dateGroups, phaseName, logoUrl, orgName, orgAddress, monthYear, landscape } = data;

    const escapeHtml = (str) =>
      String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

    const sessionHeaderCells = columns
      .map((col) => `<th class="session-th">${escapeHtml(col.session)}</th>`)
      .join("");

    const dateHeaderCells = dateGroups
      .map(
        (g) =>
          `<th colspan="${g.count}" class="date-th">
            <div>${moment(g.date).format("DD/MM/YYYY")}</div>
            <div class="day-name">${moment(g.date).format("dddd")}</div>
          </th>`
      )
      .join("");

    const bodyRows = gridRows
      .map(
        (row, ri) =>
          `<tr class="${ri % 2 === 0 ? "even" : "odd"}">
            <td class="class-td"><strong>${escapeHtml(row.className)}</strong></td>
            ${row.cells
            .map((cell) => {
              const html = escapeHtml(cell).replace(/\n/g, "<br/>");
              return `<td class="data-td">${html || "&nbsp;"}</td>`;
            })
            .join("")}
          </tr>`
      )
      .join("");

    const printScript = logoUrl
      ? "var img=document.querySelector('.print-logo');function doPrint(){window.print();}if(img&&!img.complete){img.onload=doPrint;img.onerror=doPrint;}else{doPrint();}"
      : "window.print();";

    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>Exam Timetable</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, sans-serif; padding: 20px; color: #111; font-size: 12px; }
    .header { text-align: center; margin-bottom: 16px; }
    .header img.print-logo { height: 60px; width: auto; object-fit: contain; display: block; margin: 0 auto 8px; }
    .org-name { font-size: 18px; font-weight: 800; letter-spacing: 1px; margin-bottom: 4px; }
    .org-addr { font-size: 11px; color: #555; line-height: 1.5; max-width: 640px; margin: 0 auto 8px; }
    .phase-title { font-size: 14px; font-weight: 700; margin-top: 6px; }
    table { width: 100%; border-collapse: collapse; margin-top: 8px; }
    th, td { border: 1px solid #999; padding: 8px 6px; text-align: center; vertical-align: middle; }
    .class-col { background: #f5f5f5; font-weight: 700; min-width: 90px; }
    .date-th { font-size: 11px; font-weight: 700; background: #fff; }
    .date-th .day-name { font-size: 10px; font-weight: 600; margin-top: 2px; }
    .session-th { font-size: 10px; font-weight: 700; background: #fff; }
    .class-td { text-align: center; font-weight: 700; background: #f0f4ff; }
    .data-td { font-size: 11px; min-width: 80px; }
    tr.odd td.data-td { background: #fafafa; }
    tr.odd td.class-td { background: #eef2ff; }
    @media print {
      body { padding: 8px; }
      @page { size: ${landscape ? "landscape" : "portrait"}; margin: 8mm; }
    }
  </style>
</head>
<body>
  <div class="header">
    ${logoUrl ? `<img class="print-logo" src="${escapeHtml(logoUrl)}" alt="Logo" />` : ""}
    <div class="org-name">${escapeHtml(orgName)}</div>
    ${orgAddress ? `<div class="org-addr">${escapeHtml(orgAddress)}</div>` : ""}
    <div class="phase-title">${escapeHtml(phaseName.toUpperCase())} - ${escapeHtml(monthYear)}</div>
  </div>
  <table>
    <thead>
      <tr>
        <th class="class-col" rowspan="2">CLASS</th>
        ${dateHeaderCells}
      </tr>
      <tr>${sessionHeaderCells}</tr>
    </thead>
    <tbody>${bodyRows}</tbody>
  </table>
  <script>${printScript}<\/script>
</body>
</html>`;
  };

  generateTimetablePDF = async (data) => {
    const exportData = data || (await this.prepareTimetableExport());
    if (!exportData) return null;

    const { columns, gridRows, dateGroups, phaseName, orgName, orgAddress, monthYear, landscape } = exportData;

    const doc = new jsPDF({
      orientation: landscape ? "landscape" : "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageW = doc.internal.pageSize.getWidth();
    const margin = 12;
    const usableW = pageW - 2 * margin;
    let headerY = margin;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text(orgName, pageW / 2, headerY + 6, { align: "center" });
    headerY += 10;

    if (orgAddress) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      const addrLines = doc.splitTextToSize(orgAddress, usableW);
      doc.text(addrLines, pageW / 2, headerY + 4, { align: "center" });
      headerY += addrLines.length * 4 + 2;
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(`${phaseName.toUpperCase()} - ${monthYear}`, pageW / 2, headerY + 5, { align: "center" });
    headerY += 10;

    const classColW = 22;
    const dataColW = (usableW - classColW) / columns.length;
    const h1 = 12;
    const h2 = 7;
    const rowH = 16;
    let tableY = headerY + 2;

    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(150, 150, 150);
    doc.rect(margin, tableY, classColW, h1 + h2, "FD");
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.text("CLASS", margin + classColW / 2, tableY + (h1 + h2) / 2 + 1.5, { align: "center" });

    dateGroups.forEach((g) => {
      const x = margin + classColW + g.start * dataColW;
      const w = g.count * dataColW;
      doc.setFillColor(255, 255, 255);
      doc.rect(x, tableY, w, h1, "FD");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(8);
      doc.text(moment(g.date).format("DD/MM/YYYY"), x + w / 2, tableY + 4.5, { align: "center" });
      doc.text(moment(g.date).format("dddd"), x + w / 2, tableY + 9.5, { align: "center" });
    });

    columns.forEach((col, i) => {
      const x = margin + classColW + i * dataColW;
      doc.setFillColor(255, 255, 255);
      doc.rect(x, tableY + h1, dataColW, h2, "FD");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(7);
      doc.text(col.session, x + dataColW / 2, tableY + h1 + 4.5, { align: "center" });
    });

    tableY += h1 + h2;

    gridRows.forEach((row, ri) => {
      const y = tableY + ri * rowH;
      const bg = ri % 2 === 0 ? [255, 255, 255] : [245, 245, 245];

      doc.setFillColor(...bg);
      doc.setDrawColor(150, 150, 150);
      doc.rect(margin, y, classColW, rowH, "FD");
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      const cLines = doc.splitTextToSize(row.className, classColW - 2);
      doc.text(cLines, margin + classColW / 2, y + (rowH - cLines.length * 3.5) / 2 + 3, { align: "center" });

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7.5);
      row.cells.forEach((cell, ci) => {
        const x = margin + classColW + ci * dataColW;
        doc.setFillColor(...bg);
        doc.rect(x, y, dataColW, rowH, "FD");
        doc.setTextColor(0, 0, 0);
        if (cell) {
          const lines = doc.splitTextToSize(cell, dataColW - 2);
          doc.text(lines, x + dataColW / 2, y + (rowH - lines.length * 3.2) / 2 + 3, { align: "center" });
        }
      });
    });

    return doc;
  };

  handlePrint = async () => {
    const data = await this.prepareTimetableExport();
    if (!data) return;

    const html = this.generateTimetablePrintHTML(data);
    const win = window.open("", "_blank", "width=1100,height=800");
    if (!win) {
      toast.error("Allow popups for this site to print the timetable");
      return;
    }
    win.document.open();
    win.document.write(html);
    win.document.close();
  };

  handleDownload = async () => {
    const data = await this.prepareTimetableExport();
    if (!data) return;
    const doc = await this.generateTimetablePDF(data);
    if (!doc) return;
    doc.save("exam-timetable.pdf");
  };

  /* -------------------- UI -------------------- */

  render() {
    const { tableData, selectedClasses, loader, showConfig, isSubmitting, searchQuery } = this.state;
    const { subjects, streamGroups = [] } = tableData;
    const allClasses = streamGroups.flatMap((g) => g.classes);

    const S = {
      page: {
        // background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)",
        minHeight: "100vh",
        padding: "28px 24px",
      },
      card: {
        background: "#fff",
        borderRadius: 20,
        boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
        border: "none",
        marginBottom: 24,
        overflow: "hidden",
      },
      cardHeader: {
        border: "1px solid #e5e7eb",
        background: "rgba(250, 251, 255, 1)",
        color: "#000",
        padding: "16px 24px",
        display: "flex",
        alignItems: "center",
        gap: 10,
      },
      cardHeaderTitle: { color: "#000", fontWeight: 700, fontSize: 17, margin: 0 },
      dot: { width: 8, height: 8, borderRadius: "50%", background: "rgba(255,255,255,0.6)" },
      cardBody: {
        padding: "22px 24px",
        minHeight: "100vh",
      },
      cardHeaderIcon: {
        width: 32,
        height: 32,
        borderRadius: 8,
        background: "rgb(224,231,255)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#6366f1",
        fontSize: 14,
      },
      label: {
        fontSize: 12,
        fontWeight: 600,
        color: "#6b7280",
        marginBottom: 6,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        display: "block",
      },
      select: {
        borderRadius: 10,
        border: "1.5px solid #e5e7eb",
        padding: "9px 14px",
        fontSize: 14,
        color: "#1f2937",
        background: "#f9fafb",
        width: "100%",
        outline: "none",
      },
      chip: (color = "#6366f1") => ({
        background: color === "green" ? "#f0fdf4" : "#ede9fe",
        color: color === "green" ? "#16a34a" : "#6366f1",
        border: `1px solid ${color === "green" ? "#bbf7d0" : "#c7d2fe"}`,
        borderRadius: 20,
        padding: "4px 14px",
        fontWeight: 700,
        fontSize: 13,
      }),
      btnPrimary: {
        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        border: "none",
        borderRadius: 10,
        padding: "9px 22px",
        fontWeight: 700,
        fontSize: 14,
        color: "#fff",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(99,102,241,0.3)",
      },
      btnGreen: {
        background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        border: "none",
        borderRadius: 10,
        padding: "9px 22px",
        fontWeight: 700,
        fontSize: 14,
        color: "#fff",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
      },
      btnGray: {
        background: "#f3f4f6",
        border: "1.5px solid #d1d5db",
        borderRadius: 10,
        padding: "9px 22px",
        fontWeight: 700,
        fontSize: 14,
        color: "#374151",
        cursor: "pointer",
      },
      actionBar: {
        display: "flex",
        gap: 12,
        justifyContent: "flex-end",
        flexWrap: "wrap",
        marginTop: 24,
        paddingTop: 20,
        borderTop: "1px solid #e5e7eb",
      },
      emptyState: { textAlign: "center", padding: "48px 20px", color: "#9ca3af" },
      emptyIcon: { fontSize: 48, marginBottom: 12, display: "block" },
      emptyText: { fontWeight: 600, fontSize: 15, color: "#6b7280", margin: 0 },

      // Table styles
      th: {
        padding: "12px 16px",
        fontWeight: 700,
        fontSize: 13,
        textAlign: "center",
        whiteSpace: "nowrap",
        border: "1px solid #e5e7eb",
        background: "rgba(250, 251, 255, 1)",
        color: "#000",
        borderLeft: "1px solid rgba(255,255,255,0.2)",
      },
      thClass: {
        padding: "12px 16px",
        fontWeight: 700,
        fontSize: 13,
        textAlign: "left",
        minWidth: 150,
        whiteSpace: "nowrap",
        border: "1px solid #e5e7eb",
        background: "rgba(250, 251, 255, 1)",
        color: "#000",
      },
      tdClass: {
        padding: "12px 16px",
        fontWeight: 700,
        fontSize: 13,
        color: "#374151",
        background: "#f0f4ff",
        borderBottom: "1px solid #e5e7eb",
        borderRight: "1px solid #e5e7eb",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
      },
      tdCell: {
        padding: "10px 12px",
        borderLeft: "1px solid #e5e7eb",
        borderBottom: "1px solid #e5e7eb",
        verticalAlign: "top",
        minWidth: 200,
      },
      fieldInput: {
        borderRadius: 8,
        border: "1.5px solid #e5e7eb",
        padding: "7px 10px",
        fontSize: 12,
        color: "#1f2937",
        background: "#fff",
        width: "100%",
        outline: "none",
        marginBottom: 6,
      },
      countChip: {
        background: "#ede9fe",
        color: "#6366f1",
        border: "1px solid #c7d2fe",
        borderRadius: 20,
        padding: "4px 14px",
        fontWeight: 700,
        fontSize: 13,
      },
      searchContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
        padding: "16px 20px",
        borderBottom: "1px solid #e5e7eb",
        background: "#fff",
      },
      searchWrapper: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        minWidth: 260,
      },
      searchInput: {
        padding: "8px 12px 8px 36px",
        fontSize: 14,
        borderRadius: 8,
        border: "1.5px solid #e5e7eb",
        width: "100%",
        outline: "none",
        transition: "all 0.2s ease",
      },
      searchIcon: {
        position: "absolute",
        left: 12,
        color: "#9ca3af",
        fontSize: 14,
      },
      clearSearchBtn: {
        position: "absolute",
        right: 12,
        background: "none",
        border: "none",
        color: "#9ca3af",
        cursor: "pointer",
        padding: 0,
        fontSize: 14,
      },
      pageSizeWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 14,
        color: "#4b5563",
      },
      pageSizeSelect: {
        padding: "6px 12px",
        borderRadius: 8,
        border: "1.5px solid #c084fc",
        background: "#f3e8ff",
        color: "#6b21a8",
        outline: "none",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 13,
      },
      paginationContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
        padding: "16px 20px",
        borderTop: "1px solid #e5e7eb",
        background: "#fff",
      },
      paginationInfo: {
        fontSize: 14,
        color: "#4b5563",
      },
      paginationButtons: {
        display: "flex",
        alignItems: "center",
        gap: 6,
      },
      pageBtn: {
        padding: "6px 12px",
        fontSize: 13,
        fontWeight: 600,
        borderRadius: 8,
        border: "1.5px solid #e5e7eb",
        background: "#fff",
        color: "#4b5563",
        cursor: "pointer",
        transition: "all 0.2s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 36,
        height: 36,
      },
      pageBtnActive: {
        background: "#dee2e6",
        color: "#1f2937",
        borderColor: "#dee2e6",
      },
      pageBtnDisabled: {
        background: "#f3f4f6",
        color: "#d1d5db",
        borderColor: "#e5e7eb",
        cursor: "not-allowed",
      },
    };

    // Search query — filters class rows within each stream group (by class or subject name).
    const query = searchQuery.trim().toLowerCase();
    const matchesQuery = (cls, groupSubjects) => {
      if (!query) return true;
      if ((cls.class_name || "").toLowerCase().includes(query)) return true;
      return groupSubjects.some((s) => cls.exams[s.subject_id] && (s.subject_name || "").toLowerCase().includes(query));
    };

    // Stream-section styles
    const streamHeaderStyle = {
      display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap",
      padding: "12px 16px", background: "linear-gradient(120deg, #ede9fe 0%, #f5f3ff 100%)",
      borderBottom: "1px solid #e5e7eb",
    };
    const streamBadgeStyle = {
      display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 14px",
      borderRadius: 20, background: "#6366f1", color: "#fff", fontWeight: 700, fontSize: 13,
    };

    // Search toolbar
    const searchToolbar = (
      <div style={{ ...S.searchContainer, justifyContent: "flex-end" }}>
        <div style={S.searchWrapper}>
          <i className="fa fa-search" style={S.searchIcon} />
          <input
            type="text"
            style={S.searchInput}
            placeholder="Search class or Subject..."
            value={searchQuery}
            onChange={(e) => this.setState({ searchQuery: e.target.value })}
          />
          {searchQuery && (
            <button type="button" style={S.clearSearchBtn} onClick={() => this.setState({ searchQuery: "" })}>
              <i className="fa fa-times" />
            </button>
          )}
        </div>
      </div>
    );

    return (
      <div style={S.page}>
        {/* FILTERS */}
        <div style={S.card}>
          <div style={S.cardHeader}>
            <div style={S.cardHeaderIcon}><i className="fa fa-calendar" /></div>
            <h5 style={S.cardHeaderTitle}>Create Exam Schedule</h5>
          </div>
          <div style={S.cardBody}>
            <Row>
              <Col xs={12} md={3}>
                <label style={S.label}>Academic Year</label>
                <SelectDropDown
                  name="selectedAcademicYear"
                  placeholderName="Select Academic Year"
                  options={(this.props.getYears || []).map((y) => ({ value: y.id, label: y.academic_year, id: y.id }))}
                  stateData={(this.props.getYears || []).map((y) => ({ value: y.id, label: y.academic_year, id: y.id })).find((opt) => String(opt.value) === String(this.state.selectedAcademicYear)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

              <Col xs={12} md={3}>
                <label style={S.label}>Branch</label>
                <SelectDropDown
                  name="selectedBranch"
                  placeholderName="Select Branch"
                  options={(this.props.getBranchesQuery || []).map((b) => ({ value: b.id, label: b.branch_name, id: b.id }))}
                  stateData={(this.props.getBranchesQuery || []).map((b) => ({ value: b.id, label: b.branch_name, id: b.id })).find((opt) => String(opt.value) === String(this.state.selectedBranch)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>

              <Col xs={12} md={3}>
                <label style={S.label}>Class</label>
                <SelectDropDown
                  name="selectedClass"
                  placeholderName="Select Class"
                  options={this.getClassOptions().map((o) => ({ value: o.value, label: o.label, id: o.value }))}
                  stateData={selectedClasses[0] ? { value: selectedClasses[0].value, label: selectedClasses[0].label, id: selectedClasses[0].value } : null}
                  handleChange={this.handleClassSingleChange}
                  isDisabled={!this.state.selectedBranch}
                  isClearable={false}
                />
              </Col>

              {this.getStreamOptions().length > 0 && (
                <Col xs={12} md={3}>
                  <label style={S.label}>Stream</label>
                  <MultiSelect
                    options={this.getStreamOptions()}
                    value={this.state.selectedStreams}
                    onChange={this.handleStreamChange}
                    labelledBy="Select Streams"
                    overrideStrings={{
                      selectSomeItems: "Select Streams...",
                      allItemsAreSelected: "All Streams Selected",
                      selectAll: "Select All Streams",
                      search: "Search...",
                    }}
                  />
                </Col>
              )}

              <Col xs={12} md={3}>
                <label style={S.label}>Exam Phase</label>
                <SelectDropDown
                  name="selectedExamPhase"
                  placeholderName="Select Phase"
                  options={(this.props.getExamPhase || []).filter((p) => +p.academic_year_id === +this.state.selectedAcademicYear).map((p) => ({ value: p.id, label: p.exam_phase, id: p.id }))}
                  stateData={(this.props.getExamPhase || []).filter((p) => +p.academic_year_id === +this.state.selectedAcademicYear).map((p) => ({ value: p.id, label: p.exam_phase, id: p.id })).find((opt) => String(opt.value) === String(this.state.selectedExamPhase)) || null}
                  handleChange={this.handleSelectChange}
                  isClearable={false}
                />
              </Col>
            </Row>

            {/* LOADER */}
            {loader === 1 && (
              <div className="py-4">
                <style>
                  {`
                      @keyframes shimmerLoading {
                          0% { background-position: -1000px 0; }
                          100% { background-position: 1000px 0; }
                      }
                      .shimmer-line {
                          height: 20px;
                          margin-bottom: 15px;
                          background: #f6f7f8;
                          background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
                          background-repeat: no-repeat;
                          background-size: 1000px 100%;
                          animation: shimmerLoading 1.5s infinite linear forwards;
                          border-radius: 4px;
                      }
                      .shimmer-header { height: 40px; margin-bottom: 24px; border-radius: 8px; }
                  `}
                </style>
                <div className="shimmer-line shimmer-header" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '100%' }}></div>
                <div className="shimmer-line" style={{ width: '80%' }}></div>
              </div>
            )}

            {/* EMPTY STATE */}
            {/* {!loader && !showConfig && (
              <div style={S.card} className="mt-4">
                <div style={S.cardHeader}>
                  <div style={S.dot}><i className="fa fa-calendar" /></div>
                  <h5 style={S.cardHeaderTitle}>Select Subjects &amp; Schedule</h5>
                </div>
                <div style={S.emptyState}>
                  <span style={S.emptyIcon}>👆</span>
                  <p style={S.emptyText}>Please select all dropdowns to view the Subjects &amp; Schedule.</p>
                </div>
              </div>
            )} */}

            {/* SUBJECTS TABLE */}
            {!loader && showConfig && (
              <div style={S.card} className="mt-4">
                <div style={S.cardHeader}>
                  <div style={S.cardHeaderIcon}><i className="fa fa-calendar" /></div>
                  <h5 style={S.cardHeaderTitle}>Select Subjects &amp; Schedule</h5>
                </div>

                <div style={{ padding: "16px 20px" }}>
                  {/* Count chips */}
                  <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 16, flexWrap: "wrap" }}>
                    <span style={S.countChip}>{subjects.length} Subjects</span>
                    <span style={S.countChip}>{allClasses.length} Class Rows</span>
                    <span style={S.countChip}>{streamGroups.length} Stream{streamGroups.length === 1 ? "" : "s"}</span>
                  </div>

                  {streamGroups.length > 0 ? (
                    <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, overflow: "hidden" }}>
                      {searchToolbar}

                      {/* One section per STREAM — its own subject columns; rows are its classes */}
                      {streamGroups.map((group) => {
                        const groupClasses = this.sortClassesByName(
                          group.classes.map((c) => ({ ...c, value: c.class_id }))
                        ).filter((cls) => matchesQuery(cls, group.subjects));
                        if (!groupClasses.length) return null;

                        return (
                          <div key={group.stream_id ?? "none"} style={{ borderTop: "1px solid #e5e7eb" }}>
                            <div style={streamHeaderStyle}>
                              <span style={streamBadgeStyle}>
                                <i className="fa fa-sitemap" style={{ fontSize: 11 }} />
                                {group.stream_name || "No Stream"}
                              </span>
                              <span style={{ fontSize: 12.5, color: "#6b7280", fontWeight: 600 }}>
                                {groupClasses.length} class{groupClasses.length === 1 ? "" : "es"} · {group.subjects.length} subject{group.subjects.length === 1 ? "" : "s"}
                              </span>
                            </div>

                            <div style={{ overflowX: "auto" }}>
                              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                  <tr>
                                    <th style={S.thClass}>Class</th>
                                    {group.subjects.map((s) => (
                                      <th key={s.subject_id} style={S.th}>
                                        <span style={{ textTransform: "uppercase", letterSpacing: "0.4px" }}>{s.subject_name}</span>
                                      </th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {groupClasses.map((cls, rowIdx) => (
                                    <tr key={cls.class_id} style={{ background: rowIdx % 2 === 0 ? "#fff" : "#fafafa" }}>
                                      <td style={S.tdClass}>{cls.class_name}</td>
                                      {group.subjects.map((s) => {
                                        const exam = cls.exams[s.subject_id];
                                        if (!exam) {
                                          return <td key={s.subject_id} style={S.tdCell}>—</td>;
                                        }
                                        return (
                                          <td key={s.subject_id} style={S.tdCell}>
                                            {/* Date & Time */}
                                            <div style={{ marginBottom: 6 }}>
                                              <div style={{ fontSize: 10, color: "#6b7280", fontWeight: 600, marginBottom: 3, textTransform: "uppercase" }}>
                                                Date &amp; Time
                                              </div>
                                              <input
                                                type="datetime-local"
                                                min={new Date().toISOString().slice(0, 16)}
                                                value={exam.exam_date ? `${exam.exam_date}T${exam.exam_time || "00:00"}` : ""}
                                                onChange={(e) => this.handleDateTimeChange(group.stream_id, cls.class_id, s.subject_id, e.target.value)}
                                                style={S.fieldInput}
                                              />
                                            </div>

                                            {/* Order No */}
                                            <div>
                                              <div style={{ fontSize: 10, color: "#6b7280", fontWeight: 600, marginBottom: 3, textTransform: "uppercase" }}>
                                                Order No
                                              </div>
                                              <select
                                                value={exam.order_no}
                                                onChange={(e) => this.updateExamField(group.stream_id, cls.class_id, s.subject_id, "order_no", e.target.value)}
                                                style={S.fieldInput}
                                              >
                                                {group.subjects.map((_, idx) => (
                                                  <option key={idx + 1} value={idx + 1}>{idx + 1}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div style={S.emptyState}>
                      <span style={S.emptyIcon}>📚</span>
                      <p style={S.emptyText}>No subjects found</p>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div style={S.actionBar}>
                    <button style={S.btnGray} onClick={this.handleDownload}>
                      Download Hall Ticket
                    </button>
                    <button style={S.btnPrimary} onClick={this.handlePrint}>
                      Print Hall Ticket
                    </button>
                    <button
                      style={S.btnGreen}
                      onClick={this.handlePublishExam}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save Configuration"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    );
  }
}

/* -------------------- EXPORT -------------------- */
export default withRouter(
  withApollo(
    compose(
      graphql(GET_CREATED_EXAMS, {
        name: "getCreatedExamsQuery",
        options: { variables: { class_id: "", exam_phase_id: 0 }, skip: true },
      }),
      graphql(CREATE_EXAMS, { name: "mutate" })
    )(CreateExam)
  )
);